import { sliders } from '@/configs/translates.config';

export default {
	'add-new-slider': `add new ${sliders.en.singular}`,
	slider: sliders.en.singular,
	'the-slider': `the ${sliders.en.singular}`,
}